import instanceAxios from '../config/api'
import {
  Audit,
  AuditResponse,
  CalculateAuditActionsCostsResponse,
  CorrectiveActionPrioritiesResponse,
  CorrectiveActionStatusResponse,
  SourceAuditType,
} from '../types/auditTypes'
const API_URL = '/audits'

export const getAllAudits = async ({
  page,
  pageSize,
  search,
}: {
  page?: number
  pageSize?: number
  search?: string
}) => {
  try {
    const response = await instanceAxios.get<AuditResponse>(`${API_URL}`, {
      params: {
        page,
        pageSize,
        search,
      },
    })
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch audit.')
  }
}
export const deleteAuditApi = async (AuditId: string) => {
  try {
    const response = await instanceAxios.delete<Audit[]>(
      `${API_URL}/` + AuditId
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch audits.')
  }
}

export const addAuditApi = async (newAudit: Audit): Promise<Audit> => {
  try {
    const response = await instanceAxios.post<Audit>(`${API_URL}`, newAudit)
    return response.data
  } catch (error: any) {
    throw new Error(error?.response?.data?.message || 'Failed to add Audit.')
  }
}

export const getAuditbyIdApi = async (AuditId: string) => {
  try {
    const response = await instanceAxios.get<Audit>(`${API_URL}/` + AuditId)
    return response.data
  } catch (error) {
    throw new Error('Failed to fetch audit.')
  }
}

export const updateAuditApi = async (
  updatedAudit: Audit,
  _id: string
): Promise<Audit> => {
  try {
    const response = await instanceAxios.put<Audit>(
      `${API_URL}/${_id}`,
      updatedAudit
    )
    return response.data
  } catch (error) {
    throw new Error('Failed to PUT Audit.')
  }
}

export const getAuditsByMissionIdApi = async (MissionId: string) => {
  try {
    const response = await instanceAxios.get<AuditResponse>(
      `missions/getAudits/` + MissionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch audits.')
  }
}

export const getAuditByActionIdApi = async (ActionId: string) => {
  try {
    const response = await instanceAxios.get<AuditResponse>(
      `actions/getAudits/` + ActionId
    )
    return response
  } catch (error) {
    throw new Error('Failed to fetch Audit.')
  }
}

export const addAuditsToActionApi = async (
  SourceAudit: string[],
  _id: string
): Promise<Audit[]> => {
  try {
    const response = await instanceAxios.put<Audit[]>(
      `actions/addAudits/${_id}`,
      SourceAudit
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUTAction.')
  }
}

export const removeAuditsFromActionApi = async (
  SourceAudit: SourceAuditType,
  _id: string
): Promise<Audit[]> => {
  try {
    const response = await instanceAxios.put<Audit[]>(
      `actions/removeAudits/${_id}`,
      SourceAudit
    )
    return response.data
  } catch (error) {
    console.log(error)
    throw new Error('Failed to PUTAction.')
  }
}
export const calculateAuditActionsCostsApi = async (
  auditId: string
): Promise<CalculateAuditActionsCostsResponse> => {
  try {
    const response =
      await instanceAxios.get<CalculateAuditActionsCostsResponse>(
        `${API_URL}/calculateAuditActionsCosts/${auditId}`
      )
    return response.data
  } catch (error) {
    console.error('Failed to fetch audit action costs:', error)
    throw new Error('Failed to calculate audit actions costs.')
  }
}
export const getCorrectiveActionPrioritiesForAuditApi = async (
  auditId: string
): Promise<CorrectiveActionPrioritiesResponse> => {
  try {
    const response =
      await instanceAxios.get<CorrectiveActionPrioritiesResponse>(
        `${API_URL}/getCorrectiveActionPrioritiesForAudit/${auditId}`
      )
    return response.data
  } catch (error) {
    console.error('Failed to fetch corrective action priorities:', error)
    throw new Error('Failed to fetch corrective action priorities.')
  }
}
export const getCorrectiveActionStatusForAuditApi = async (
  auditId: string
): Promise<CorrectiveActionStatusResponse> => {
  try {
    const response = await instanceAxios.get<CorrectiveActionStatusResponse>(
      `${API_URL}/getCorrectiveActionStatusForAudit/${auditId}`
    )
    return response.data
  } catch (error) {
    console.error('Failed to fetch corrective action statuses:', error)
    throw new Error('Failed to fetch corrective action statuses.')
  }
}
